import React, { useId, useState } from 'react';

const sanitizeId = (value) => (value || '').toString().replace(/[^a-zA-Z0-9_-]/g, '-');

export default function TextInputWithSuggestions({
  id,
  name,
  value,
  onChange,
  options = [],
  placeholder = 'Select or type…',
  className = '',
  disabled = false,
  required = false,
  autoComplete = 'off',
  showAllOnFocus = false,
  onFocus,
  onBlur,
  ...rest
}) {
  const generatedId = useId();
  const fallbackId = sanitizeId(id || name || generatedId);
  const inputId = id || fallbackId;
  const listId = `${fallbackId}-suggestions`;
  const [isFocused, setIsFocused] = useState(false);
  const [hasTypedSinceFocus, setHasTypedSinceFocus] = useState(false);

  const handleFocus = (event) => {
    setIsFocused(true);
    setHasTypedSinceFocus(false);
    if (typeof onFocus === 'function') {
      onFocus(event);
    }
  };

  const handleBlur = (event) => {
    setIsFocused(false);
    if (typeof onBlur === 'function') {
      onBlur(event);
    }
  };

  const handleChange = (event) => {
    setHasTypedSinceFocus(true);
    if (typeof onChange === 'function') {
      onChange(event);
    }
  };

  const displayValue = showAllOnFocus && isFocused && !hasTypedSinceFocus ? '' : (value ?? '');

  return (
    <>
      <input
        id={inputId}
        name={name}
        type="text"
        list={options.length > 0 ? listId : undefined}
        value={displayValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        autoComplete={autoComplete}
        className={`w-full px-3 py-1 border border-[var(--ds-control-field-border)] rounded-md bg-[var(--ds-control-field-bg)] text-[var(--ds-text-primary)] dark:text-white placeholder:text-[var(--ds-text-muted)] focus:outline-none focus:ring-2 focus:ring-[var(--ds-accent-focus-ring)] focus:border-[var(--ds-accent-primary)] ${className}`}
        {...rest}
      />
      {options.length > 0 && (
        <datalist id={listId}>
          {options.map((option) => (
            <option key={option} value={option} />
          ))}
        </datalist>
      )}
    </>
  );
}


